module.exports = __webpack_public_path__ + "images/frontpage_settings@1x.png?cf9bc403";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_settings@1x.png
// module id = 657
// module chunks = 7